export const patternEnum = (value, options) => {
    if (!value || !options || options.length === 0) 
        return value;
    
    const opt = options.find(opt => opt.value === value || opt.id === value);    
    return opt ? opt.label : capitalizeWords(value);
}

export const capitalizeWords = (text) => {
    return text
        .toLowerCase()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}